// @flow
import React, {Component} from 'react'
import Axios from 'axios'
import { numberFormatter } from './utils'
import { Row } from 'antd'

type Props = {
  symbol: string
}

type State = {
  data: Object[],
  columns: Object,
  rows: Object,
  report: Object,
  reportDate: Object[],
  isLoading: boolean
}

class FinancialInfo extends Component<Props, State> {

  state: State = {
    data: [],
    rows: {
      'Income Statement': [
        {name: 'Research & development', id: 'researchAndDevelopment'},
        {name: 'Operating expense', id: 'operatingExpense'},
        {name: 'Operating income', id: 'operatingIncome'},
        {name: 'Net income', id: 'netIncome'},
        {name: 'Total revenue', id: 'totalRevenue'},
        {name: 'Cost of revenue', id: 'costOfRevenue'},
        {name: 'Operating revenue', id: 'operatingRevenue'},
        {name: 'Gross profit', id: 'grossProfit'}
      ],
      'Balance Sheet': [
        {name: 'Current assets', id: 'currentAssets'},
        {name: 'Total assets', id: 'totalAssets'},
        {name: 'Current debt', id: 'currentDebt'},
        {name: 'Total debt', id: 'totalDebt'},
        {name: 'Total liabilities', id: 'totalLiabilities'},
        {name: 'Current cash', id: 'currentCash'},
        {name: 'Total cash', id: 'totalCash'},
        {name: 'Shareholder equity', id: 'shareholderEquity'}
      ],
      'Cash Flow': [
        { name: 'Cash change', id: 'cashChange' },
        { name: 'Cash flow', id: 'cashFlow' },
        { name: 'Operating gains losses', id: 'operatingGainsLosses'}
      ]
    },
    columns: {
      'Income Statement': [{ title: 'Income Statement'}],
      'Balance Sheet': [{title: 'Balance Sheet'}],
      'Cash Flow': [{ title: 'Cash Flow'}]
    },
    report: {},
    reportDate: [],
    isLoading: true
  }

  componentDidMount() {

    this.getFinancialData()
  }

  getFinancialData = async () => {

    const { symbol } = this.props

    try {

        const response = await Axios.get(`https://cloud.iexapis.com/v1/stock/${symbol}/financials?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`)

        if (response && response.data && response.data.financials) {

          this.setState({
            data: response.data.financials,
            isLoading: false,
          },() => {
            this.setTableColumns()
          })

        } else {

          this.setState({
            isLoading: false,
          })
        }

    } catch(err) {

      this.setState({
        isLoading: false,
      })
    }
  }

  setTableColumns = () => {

    const { data, columns } = this.state
    const reportDate = []
    const report = {}

    data.forEach(col  => {
      reportDate.push(col.reportDate)
      Object.keys(columns).forEach(key => {
        columns[key].push({title: col.reportDate})
      })
    })

    reportDate.forEach((date: any) => {
      report[date] = data.find(report => report.reportDate === date) || {}
    })

    this.setState({
      columns,
      reportDate,
      report
    })
  }

  render() {

    const {
      rows,
      columns,
      reportDate,
      report,
      isLoading
    } = this.state

    return (
      <Row>
        { isLoading ?
          <div>Loading....</div> :
          <div>
            {
              Object.keys(columns).map(key => (
                <table key={key} className='table is-fullwidth'>
                  <thead>
                  <tr>
                    {columns[key].map((col, i) => <th key={i}>{col.title}</th>)}
                  </tr>
                  </thead>
                  <tbody>
                    {
                      rows[key].map((row, i) => (
                        <tr key={i}>
                          <td style={{width: '17%'}}>{row.name}</td>
                          {
                            reportDate.map((date, j) => {
                              return <td
                                key={j}>{(report[date] && report[date][row.id] && numberFormatter(report[date][row.id], 2)) || 0}</td>
                            })
                          }
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              ))
            }
          </div>
        }
      </Row>
    )
  }
}

export default FinancialInfo


// WEBPACK FOOTER //
// ./src/components/view-fincancials/index.js